import React from "react"
import { makeStyles } from "@material-ui/core"
import { themeColors } from "letalkui"

const useStyles = makeStyles({
	emptyState: {
		padding: "48px 24px",
		textAlign: "center" as React.CSSProperties["textAlign"],
		color: themeColors.colors.system.gray[500]
	},
	tooltipContainer: {
		backgroundColor: themeColors.colors.system.gray[0],
		padding: "12px",
		borderRadius: "6px",
		border: `1px solid ${themeColors.colors.system.gray[50]}`,
		boxShadow: "0 4px 4px 0 rgba(74, 74, 74, 0.15)",
		minWidth: "180px"
	},
	tooltipDate: {
		fontSize: "12px",
		fontWeight: 600,
		color: themeColors.colors.system.gray[800],
		marginBottom: "4px"
	},
	tooltipRow: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		gap: "24px",
		paddingTop: "4px",
		paddingBottom: "4px"
	},
	tooltipLabelWrapper: {
		display: "flex",
		alignItems: "center",
		gap: "8px"
	},
	tooltipColorDot: {
		width: "10px",
		height: "10px",
		borderRadius: "50%",
		flexShrink: 0
	},
	tooltipLabel: {
		fontSize: "10px",
		color: themeColors.colors.system.gray[700]
	},
	tooltipValue: {
		fontSize: "10px",
		fontWeight: 600,
		color: themeColors.colors.system.gray[500]
	},
	legendWrapper: {
		marginTop: "8px"
	},
	legendItem: {
		display: "flex",
		alignItems: "center",
		gap: "6px"
	},
	legendColorDot: {
		width: "10px",
		height: "10px",
		borderRadius: "50%",
		flexShrink: 0
	},
	legendText: {
		fontSize: "10px",
		color: themeColors.colors.system.gray[500]
	}
})

export default useStyles
